var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParameter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.00046 3.40148L9.51013 11.9112C9.82912 12.2267 10.26 12.4032 10.7086 12.402C11.1572 12.4009 11.5872 12.2223 11.9046 11.9052C12.2227 11.5868 12.4014 11.1551 12.4014 10.705C12.4014 10.2549 12.2227 9.8232 11.9046 9.50475L3.40093 1.00098",
    stroke: "#551EE3",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00098 0.400391L0.400269 4.00114",
    stroke: "#551EE3",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.4012 8.80176H11.2021",
    stroke: "#551EE3",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParameter);
export default __webpack_public_path__ + "static/media/Parameter.7f53545b45caf4b22efdbe14f9b684f6.svg";
export { ForwardRef as ReactComponent };